import { Typography } from 'antd';
import styled from 'styled-components';

export const Link = styled(Typography.Link)`
  font-size: 16px;
  cursor: pointer;
  &:hover {
    opacity: 0.6;
  }
`;
